import React from 'react';
import {
  Box,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  Chip,
} from '@mui/material';

export default function SponsoredCountDropPanel({ payload }) {
  const journeys = payload?.journeys || [];
  return (
    <Box>
      <Box sx={{ display: 'flex', gap: 1, mb: 1.5, flexWrap: 'wrap' }}>
        <Chip size="small" label={`Threshold: ${payload?.drop_pct_threshold ?? 20}% drop`} />
        <Chip size="small" label={`Min hist avg: ${payload?.min_hist_avg_sponsored ?? 3}`} />
        <Chip size="small" label={`Sampled: ${payload?.sampled_journey_count ?? journeys.length}`} />
        <Chip size="small" label={`Total with drop: ${payload?.total_journeys_with_drop ?? '—'}`} />
      </Box>
      {journeys.length === 0 ? (
        <Typography variant="body2" color="text.secondary">No sampled journeys.</Typography>
      ) : (
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Journey</TableCell>
              <TableCell>Current</TableCell>
              <TableCell>Hist avg</TableCell>
              <TableCell>Drop %</TableCell>
              <TableCell>Reasons</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {journeys.map((j, idx) => (
              <TableRow key={`${j.journey}-${idx}`}>
                <TableCell>{j.journey}</TableCell>
                <TableCell>{j.current_sponsored_count}</TableCell>
                <TableCell>{j.hist_avg_sponsored_count}</TableCell>
                <TableCell>{j.sponsored_drop_pct}</TableCell>
                <TableCell>{j.sponsored_drop_reasons || '—'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </Box>
  );
}
